/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {Progress as SProgress} from 'semantic-ui-react'


class Progress extends React.Component {

    render() {
        let progress = this.props.value > 100 ? 100 : this.props.value
        progress = Math.round(progress)
        return (
            <div className="hdr-progress-wrapper">
                <SProgress percent={progress} color={!this.props.color ? 'blue' : this.props.color} size="tiny" disabled={this.props.disabled}/>
                <div className="progress-value">{this.props.disabled ? '' : progress}</div>
            </div>
        )
    }
}


export default Progress